import React from 'react'
import { useEvent } from '@/modules/event/eventSlice'
import Head from "next/head";

const Tealium = () => {

  const event = useEvent()
  const [tealiumKey, setTealiumKey] = React.useState('')

  React.useEffect(() => {
    if (event) {
      if (event.tealiumTagManagerKey) {
        setTealiumKey(event.tealiumTagManagerKey)
      }
    }
  }, [event])

  return (
    tealiumKey
    ? <Head>
        <script>
        {
          `
            (function(a,b,c,d){
            a='//tags.tiqcdn.com/utag/${tealiumKey}/main/${process.env.NODE_ENV === 'production' ? 'prod' : 'dev'}/utag.js';
            b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
            a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
            })();
          `
        }
        </script>
      </Head>
    : <></>
  )
}

export default Tealium
